// extracted by mini-css-extract-plugin
export default {"main_container":"Home_main_container__4AOCI","right_content":"Home_right_content__BvoEv"};